'use client'

import { useFeatures } from '@/components/providers/site/FeatureProvider'
import { useParams, useRouter } from 'next/navigation'
import { PropsWithChildren, useEffect } from 'react'

export const CmsToTtapiRedirect = ({ children }: PropsWithChildren) => {
  const features = useFeatures()
  const router = useRouter()
  const params = useParams()

  useEffect(() => {
    // Check if the TTAPI pages feature is enabled
    if (features.featTtapiPages) {
      const locale = params.locale as string
      const organizationKey = params.organizationKey as string
      const model = params.model as string[] | undefined

      // Get the current CMS page slug/model
      const cmsSlug = model?.[0] || ''

      if (cmsSlug) {
        // Redirect to the /p equivalent
        const ttapiPath = `/${locale}/${organizationKey}/p/${cmsSlug}`
        router.replace(ttapiPath)
      }
    }
  }, [features.featTtapiPages, params, router])

  // If TTAPI pages are enabled, don't render children (we're redirecting)
  if (features.featTtapiPages) {
    return null
  }

  // Otherwise, render the normal CMS content
  return <>{children}</>
}